module.exports = __webpack_public_path__ + "img/aeroplane.744c6cf5.svg";